import { Routes } from '@angular/router';
import { AddTeamlidPage } from './page/add-teamlid-page/add-teamlid.page';
import { QrCodeScanPage } from './page/qr-code-scan-page/qr-code-scan.page';

export const teamAddRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'team.add-teamlid.title',
        component: AddTeamlidPage,
      },
      {
        path: 'qr-code-scan',
        title: 'profiel.qr-code-title',
        component: QrCodeScanPage,
      },
    ],
  },
];
